import React from "react";
import ClientHistory from "components/pages/clients/ClientsShow/ClientHistory.js";

const PhysiciansTab = ({ clientId }) => {
  return <ClientHistory clientId={clientId} />;
};

export default PhysiciansTab;
